import { userDetailsStore } from 'stores/userDetailsStore/userDetailsStore'

export const userCanCreateReports = () => {
  const userPermissions = userDetailsStore.getState().permissions

  return Object.keys(userPermissions).some((p) => p.startsWith('CREATE_REPORT'))
}
